<div class="container-fluid" data-cy="divRegistrationWizardContactContainer">
  <div class="form-horizontal">
    <h3>{{ 'events.registration.wizard.contact.title' | translate | titlecase }}</h3>

    <div class="form-group" *ngIf="!registration.Registration.CreateProfile && registration.Registration.ProfileId >= 0">
      <label class="col-sm-3 col-lg-2 control-label" for="profileOrgLookup">{{
        'events.registration.wizard.contact.profile-lookup-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <wl-profile-selector
          name="profileOrgLookup"
          [(ngModel)]="registration.Registration.ProfileId"
          (onProfileChanged)="registrationProfileChanged($event)"
        ></wl-profile-selector>
        <!--{{registration.Registration.ProfileId}}-->
      </div>
    </div>
    <div class="form-group" *ngIf="registration.Registration.ProfileId == 0">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationChkCreateProfile">{{
        'events.registration.wizard.contact.create-profile-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <div class="form-control-static">
          <input
            type="checkbox"
            id="registrationChkCreateProfile"
            name="registrationChkCreateProfile"
            [(ngModel)]="registration.Registration.CreateProfile"
          />
        </div>
      </div>
    </div>

    <div
      class="form-group"
      *ngIf="
        registration.IsEdit &&
        registration.Registration.ProfileId > 0 &&
        registration.Registration.ProfileId != _copiedValuesProfileId &&
        _lastChosenProfile
      "
    >
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <button pButton type="button" class="btn btn-default" (click)="handleCopyProfileInfoClick()" icon="pi pi-arrow-circle-down">
          {{ 'events.registration.wizard.overwrite-values-from-profile' | translate | titlecase }}
        </button>
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegCompanyNameVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationContactOrgName">{{
        'events.registration.wizard.contact.org-name-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input
          class="form-control"
          type="text"
          name="registrationContactOrgName"
          [(ngModel)]="registration.Registration.OrgName"
          (blur)="onOrgNameChange()"
        />

        <div>
          <wl-profile-dup-checker
            #profileOrgDupChecker
            (onProfileSelected)="onDupCheckerOrgNameProfileSelected($event)"
            sourceModule="events"
          ></wl-profile-dup-checker>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="!registration.IsEdit && registration.Registration.ProfileId > 0">
      <label class="col-sm-3 col-lg-2 control-label" for="profileRelatedLookup">{{
        'events.registration.wizard.contact.profile-related-lookup-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <wl-related-profile-selector
          name="profileRelatedLookup"
          [(ngModel)]="registration.Registration.relatedProfileId"
          [relatedProfileId]="registration.Registration.ProfileId"
          (onProfileChanged)="relatedProfileChanged($event)"
          [disabled]="_checkingMainContact"
          [includeSelectValue]="true"
        ></wl-related-profile-selector>
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegPrefixVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationPrefix">{{
        'events.registration.wizard.contact.prefix-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input class="form-control" type="text" name="registrationPrefix" [(ngModel)]="registration.Registration.Prefix" />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegFNameVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationFirstName">{{
        'events.registration.wizard.contact.first-name-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input class="form-control" type="text" name="registrationFirstName" [(ngModel)]="registration.Registration.FName" />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegLNameVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationLastName">{{
        'events.registration.wizard.contact.last-name-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input
          class="form-control"
          type="text"
          name="registrationLastName"
          [(ngModel)]="registration.Registration.LName"
          (blur)="onLastNameChange()"
        />
      </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-lg-offset-2 col-sm-9 col-lg-10">
        <wl-profile-dup-checker
          #profileIndDupChecker
          (onProfileSelected)="onDupCheckerIndNameProfileSelected($event)"
          sourceModule="events"
        ></wl-profile-dup-checker>
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegEmailVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationEmail">{{
        'events.registration.wizard.contact.email-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input class="form-control" type="text" name="registrationEmail" [(ngModel)]="registration.Registration.Email" />
        <div class="checkbox" *ngIf="!registration.IsEdit">
          <label>
            <input type="checkbox" [(ngModel)]="registration.DoNotSendNotification" />
            <span>{{ 'events.registration.wizard.contact.do-not-send-email-label' | translate | titlecase }}</span> </label
          ><!--{{registration.DoNotSendNotification}}-->
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegAddressVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationAddress1">{{
        'events.registration.wizard.contact.address-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <div [wl-busy-overlay]="_checkingBillingContact" [busyMessage]="'common.loading' | translate | titlecase">
          <div class="form-group">
            <div class="col-sm-12">
              <input class="form-control" type="text" name="registrationAddress1" [(ngModel)]="registration.Registration.Address1" />
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12">
              <input class="form-control" type="text" name="registrationAddress2" [(ngModel)]="registration.Registration.Address2" />
            </div>
          </div>
          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <label class="col-sm-12" for="registrationCity">{{
                  'events.registration.wizard.contact.city-label' | translate | titlecase
                }}</label>
                <div class="col-sm-12">
                  <input class="form-control" type="text" name="registrationCity" [(ngModel)]="registration.Registration.City" />
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="col-sm-12" for="registrationState">{{
                  'events.registration.wizard.contact.state-label' | translate | titlecase
                }}</label>
                <div class="col-sm-12">
                  <wl-state-selector name="registrationState" [(ngModel)]="registration.Registration.State"></wl-state-selector>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-12" for="registrationZip">{{
                  'events.registration.wizard.contact.zip-label' | translate | titlecase
                }}</label>
                <div class="col-sm-12">
                  <input class="form-control" type="text" name="registrationZip" [(ngModel)]="registration.Registration.Zip" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-12" for="registrationCountry">{{
              'events.registration.wizard.contact.country-label' | translate | titlecase
            }}</label>
            <div class="col-sm-12">
              <input class="form-control" type="text" name="registrationCountry" [(ngModel)]="registration.Registration.Country" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="displayField(event.RegTitleVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationTitle">{{
        'events.registration.wizard.contact.title-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input class="form-control" type="text" name="registrationTitle" [(ngModel)]="registration.Registration.Title" />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegPhoneVisible)">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationPhone">{{
        'events.registration.wizard.contact.phone-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <input class="form-control" type="text" name="registrationPhone" [(ngModel)]="registration.Registration.Phone" />
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-3 col-lg-2 control-label" for="registrationDate">{{
        'events.registration.wizard.contact.registration-date-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-10">
        <wl-date-selector name="registrationDate" [(ngModel)]="registration.Registration.SignUpDate"></wl-date-selector>
      </div>
    </div>
    <!--<div class="form-group">
            <div class="col-sm-3 col-lg-2">
                <h4>Custom Fields Here...</h4>
            </div>
        </div>-->
  </div>
</div>
